import { render, staticRenderFns } from "./ProjectCell.vue?vue&type=template&id=2f38242a&scoped=true"
import script from "./ProjectCell.vue?vue&type=script&lang=js"
export * from "./ProjectCell.vue?vue&type=script&lang=js"
import style0 from "./ProjectCell.vue?vue&type=style&index=0&id=2f38242a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f38242a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/crm1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f38242a')) {
      api.createRecord('2f38242a', component.options)
    } else {
      api.reload('2f38242a', component.options)
    }
    module.hot.accept("./ProjectCell.vue?vue&type=template&id=2f38242a&scoped=true", function () {
      api.rerender('2f38242a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pm/components/ProjectCell.vue"
export default component.exports